// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"157db14f","239":"73ca492c","391":"a6be807b"}[chunkId] + ".chunk.js";
};